<ng-template #modalLG let-modal style="border-radius: 8px">


    <div class="modal-header p-0" style="background-color: transparent;">
        <button type="button" class=" close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')"
                aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div style="margin: 64px">
        <div class=" text-center mb-4">
            <h4 class="size24">Remise en banque</h4>
        </div>

        <div class="modal-body p-0" tabindex="0" ngbAutofocus>


            <div class="d-flex justify-content-center align-items-center stepper-wrapper mb-4">

                <div class="step-item" [class.completed]="currentStep > 1">
                    <div class="step" 
                         [class.active]="currentStep === 1" 
                         [class.completed]="currentStep > 1"
                         [style.cursor]="'pointer'"
                         (click)="goToStep(1)">
                        <div class="circle">1</div>
                        <span>Type de remise</span>
                    </div>
                    <div class="line"></div>
                </div>

                <div class="step-item" [class.completed]="currentStep > 2">
                    <div class="step" 
                         [class.active]="currentStep === 2" 
                         [class.completed]="currentStep > 2"
                         [style.cursor]="currentStep > 1 ? 'pointer' : 'default'"
                         (click)="currentStep > 1 && goToStep(2)">
                        <div class="circle">2</div>
                        <span>Informations basiques</span>
                    </div>
                    <div class="line"></div>
                </div>

                <div class="step-item" [class.completed]="currentStep > 3">
                    <div class="step" 
                         [class.active]="currentStep === 3" 
                         [class.completed]="currentStep > 3"
                         [style.cursor]="currentStep > 2 ? 'pointer' : 'default'"
                         (click)="currentStep > 2 && goToStep(3)">
                        <div class="circle">3</div>
                        <span>Informations complémentaires</span>
                    </div>
                    <div class="line"></div>
                </div>

                <div class="step-item" [class.completed]="currentStep > 4">
                    <div class="step" 
                         [class.active]="currentStep === 4" 
                         [class.completed]="currentStep > 4"
                         [style.cursor]="currentStep > 3 ? 'pointer' : 'default'"
                         (click)="currentStep > 3 && goToStep(4)">
                        <div class="circle">4</div>
                        <span>Validation</span>
                    </div>
                </div>

            </div>
            <!-- Stepper
            <div class="d-flex   stepper-wrapper mb-4">
                <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
                    <div class="circle">1</div>
                    <span>Type et montant</span>
                </div>
                <div class="line"></div>
                <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
                    <div class="circle">2</div>
                    <span>Informations sur les dépenses</span>
                </div>
                <div class="line"></div>
                <div class="step" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
                    <div class="circle">3</div>
                    <span>Informations complémentaires</span>
                </div>
                <div class="line"></div>
                <div class="step p-0 m-0" [class.active]="currentStep === 4" [class.completed]="currentStep > 4">
                    <div class="circle ">4</div>
                    <span>Note</span>
                </div>
                <div class="line"></div>
                <div class="step" [class.active]="currentStep === 5" [class.completed]="currentStep > 5">
                    <div class="circle">5</div>
                    <span>Terminé</span>
                </div>
            </div>-->

            <!-- Example step content -->
            <div *ngIf="currentStep === 1">
                <div class="items" style="margin-bottom: 24px">

                    <div class="col-lg-12 p-0">
                        <label>Montant <span class="text-danger">*</span> </label>
                        <input type="number"
                               class="form-control"
                               [(ngModel)]="formData.montant_total"
                               (ngModelChange)="numberValue = formData.montant_total; updateDisabledStates()"
                               name="montant_total"
                               placeholder="Entrez le montant"
                               step="0.001"
                               min="0"
                               [max]="maxValue"
                               required>
                    </div>

                </div>

                <div class="items " style="margin-bottom: 24px">

                        <div class="type flex-grow-1 cursor-pointer"
                             [class.selected]="formData.type_remise === 'traite'"
                             (click)="formData.type_remise = 'traite'; onTypeRemiseChange()">
                            <div class="d-flex flex-column" style="width: 100%; height: 100%;padding: 22px">
                                <div class="d-flex align-items-center" style="margin-bottom: 12px;gap: 6px">
                                    <input type="radio" id="traite" name="productType" value="traite" 
                                           [(ngModel)]="formData.type_remise" 
                                           (ngModelChange)="onTypeRemiseChange()"
                                           class="custom-radio"
                                           style="margin-right: 8px;">
                                    <i data-feather="file-text" [size]="16" style="margin-right: 16px;"></i>
                                    <label class="size15 mb-0" for="traite" style="cursor: pointer;">Traites</label>
                                </div>
                                <div [style.color]="formData.type_remise === 'traite' ? '#134AD3' : '#CB3A3A'" 
                                     class="size15"
                                     style=" margin-top: auto;margin-left: 16px">
                                    {{ montantTraites.toLocaleString('fr-FR', {minimumFractionDigits: 3, maximumFractionDigits: 3}) }} TND
                                </div>
                            </div>
                        </div>

                        <div class="type flex-grow-1 cursor-pointer pr-0"
                             [class.selected]="formData.type_remise === 'cheque'"
                             (click)="formData.type_remise = 'cheque'; onTypeRemiseChange()">
                            <div class="d-flex flex-column" style="width: 100%; height: 100%;padding: 22px">
                                <div class="d-flex align-items-center" style="margin-bottom: 12px;gap: 6px">
                                    <input type="radio" id="cheque" name="productType" value="cheque" 
                                           [(ngModel)]="formData.type_remise" 
                                           (ngModelChange)="onTypeRemiseChange()"
                                           class="custom-radio"
                                           style="margin-right: 8px;">
                                    <i data-feather="credit-card" [size]="16" style="margin-right: 16px;"></i>
                                    <label class="size15 mb-0" for="cheque" style="cursor: pointer;">Chèque</label>
                                </div>
                                <div [style.color]="formData.type_remise === 'cheque' ? '#134AD3' : '#CB3A3A'" 
                                     class="size15"
                                     style=" margin-top: auto;margin-left: 16px">
                                    {{ montantCheques.toLocaleString('fr-FR', {minimumFractionDigits: 3, maximumFractionDigits: 3}) }} TND
                                </div>
                            </div>
                        </div>

                        <div class="type flex-grow-1 cursor-pointer pr-0"
                             [class.selected]="formData.type_remise === 'espece'"
                             (click)="formData.type_remise = 'espece'; onTypeRemiseChange()">
                            <div class="d-flex flex-column" style="width: 100%; height: 100%;padding: 22px">
                                <div class="d-flex align-items-center" style="margin-bottom: 12px;gap: 6px">
                                    <input type="radio" id="espece" name="productType" value="espece" 
                                           [(ngModel)]="formData.type_remise" 
                                           (ngModelChange)="onTypeRemiseChange()"
                                           class="custom-radio"
                                           style="margin-right: 8px;">
                                    <i data-feather="dollar-sign" [size]="16" style="margin-right: 16px;"></i>
                                    <label class="size15 mb-0" for="espece" style="cursor: pointer;">Espèces</label>
                                </div>
                                <div [style.color]="formData.type_remise === 'espece' ? '#134AD3' : '#CB3A3A'" 
                                     class="size15"
                                     style=" margin-top: auto;margin-left: 16px">
                                    {{ montantEspeces.toLocaleString('fr-FR', {minimumFractionDigits: 3, maximumFractionDigits: 3}) }} TND
                                </div>
                            </div>
                        </div>

                </div>
            </div>

            <div *ngIf="currentStep === 2">
                <div class="items" style="margin-bottom: 24px">
                    <div style="flex-grow: 1;">
                        <label>Numéro de la remise <span class="text-danger">*</span> </label>
                        <input type="text" placeholder="Entrez le numéro de la remise"
                               class="form-control"
                               [(ngModel)]="formData.numero_remise"
                               name="numero_remise"
                               required>
                    </div>
                    <div style="flex-grow: 1;">
                        <label>Date de banque <span class="text-danger">*</span> </label>
                        <input type="date"
                               class="form-control"
                               [(ngModel)]="formData.date_banque"
                               name="date_banque"
                               required>
                    </div>
                </div>
                
                <div class="items" style="margin-bottom: 24px">
                    <div class="col-lg-12 p-0">
                        <label>Compte bancaire <span class="text-danger">*</span> </label>
                        <div *ngIf="comptesBancaires.length === 0" class="alert alert-warning">
                            Aucun compte bancaire disponible
                        </div>
                        <div *ngIf="comptesBancaires.length > 0">
                            <app-compte-bancaire 
                                #compteBancaire
                                [accounts]="comptesBancaires"

                                [showStatusSwitch]="false"

                                [showAddCard]="false"
                                [selectable]="true"
                                [selectedAccountId]="formData.compte_bancaire_id"
                                (accountSelected)="selectCompteBancaire($event)">
                            </app-compte-bancaire>
                        </div>
                    </div>
                </div>

            </div>

            <div *ngIf="currentStep=== 3">
                <div class="center" style="margin-bottom: 24px">
                    <div class="d-flex " style="gap: 30px">
                        <div class="border-dashed rounded text-center total-box pl-1 pr-1">

                            <div class=" total-number">

                                <span style="color: #2F2B3DE5; font-size: 15px">Solde disponible ({{ formData.type_remise === 'cheque' ? 'Chèques' : formData.type_remise === 'traite' ? 'Traites' : 'Espèces' }} en coffre) :</span> {{ soldeDisponible.toLocaleString('fr-FR', {minimumFractionDigits: 3, maximumFractionDigits: 3}) }} TND
                            </div>

                        </div>
                        <div class="">
                            <label class="form-label">Solde déposé <span class="text-danger">*</span> </label>
                            <div class="input-group">
                                <button class="minus-button-left" (click)="decrement()" [disabled]="disabledValueDecrement">-</button>
                                <input type="number" class="form-control text-center" [(ngModel)]="numberValue" (ngModelChange)="formData.montant_total = numberValue; updateDisabledStates()" name="montant_depose" [max]="maxValue"/>
                                <button class="minus-button-right" (click)="increment()" [disabled]="disabledValueIncrement">+</button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div *ngIf="currentStep===4">
                <div class="row mt-4">
                    <!-- Coordonnées bancaires -->
                    <div class="col-lg-6">
                        <p style="color:#2F2B3DE5"><strong class="size15">Coordonnées bancaires</strong></p>
                        <hr class="section-line" style="border: 1px solid #134AD3">

                        <table class=" custom-table">
                            <tr>
                                <td class="label">Nom de la banque</td>
                                <td>{{ compteBancaireSelectionne?.nom || '--' }}</td>
                            </tr>
                            <tr>
                                <td class="label">Désignation</td>
                                <td>{{ compteBancaireSelectionne?.designation || '--' }}</td>
                            </tr>
                            <tr>
                                <td class="label">Agence</td>
                                <td>{{ compteBancaireSelectionne?.agence || '--' }}</td>
                            </tr>
                            <tr>
                                <td class="label">RIB</td>
                                <td>{{ compteBancaireSelectionne?.rib || '--' }}</td>
                            </tr>
                        </table>
                    </div>

                    <!-- Détails du dépôt -->
                    <div class="col-lg-6">
                        <p style="color:#2F2B3DE5"><strong class="size15">Détails du dépôt</strong></p>
                        <hr class="section-line" style="border: 1px solid #134AD3">

                        <table class="custom-table">
                            <tr>
                                <td class="label">Type</td>
                                <td>{{ getTypeRemiseLabel() }}</td>
                            </tr>
                            <tr>
                                <td class="label">Numéro de la remise</td>
                                <td>{{ formData.numero_remise || '--' }}</td>
                            </tr>
                            <tr>
                                <td class="label">Montant</td>
                                <td style="color:#134AD3">{{ formData.montant_total.toLocaleString('fr-FR', {minimumFractionDigits: 3, maximumFractionDigits: 3}) }} TND</td>
                            </tr>
                            <tr>
                                <td class="label">Date de banque</td>
                                <td>{{ formatDate(formData.date_banque) }}</td>
                            </tr>
                        </table>
                    </div>
                </div>


                <div class="center col-lg-12" style="margin-bottom: 24px;margin-top: 24px">
                    <label>Note</label>
                    <textarea type="text"
                              class="form-control"
                              [(ngModel)]="formData.note"
                              name="note"
                              rows="3"> </textarea>
                </div>
            </div>


        </div>
        <div class="centerButtons">

            <button *ngIf="currentStep > 1" type="button" class="btn btn-grey"
                    (click)="prevStep()" rippleEffect>
                Retour
            </button>
            <button *ngIf="currentStep === 1" type="button" class="btn btn-grey" (click)="modal.close('Accept click')"
                    rippleEffect>
                Annuler
            </button>

            <button *ngIf="currentStep < 4" type="button" class="btn btn-primary"
                    (click)="nextStep()" rippleEffect>
                Continuer
            </button>
            <button *ngIf="currentStep === 4" type="button" class="btn btn-primary"
                    (click)="validateRemise()"
                    [disabled]="isLoading"
                    rippleEffect>
                <span *ngIf="isLoading">Enregistrement...</span>
                <span *ngIf="!isLoading">Valider</span>
            </button>
        </div>

    </div>
</ng-template>

